import GlobalPageSupport = Infospeed.Services.ClassWeb.API.Contracts.COT.GlobalPageSupport;

import { Injectable } from '@angular/core';
import { CotHttp, UrlDataEnum } from '../../../http-communication/cot-http.service';
import { Observable } from 'rxjs';

@Injectable()
export class HarrowFooterService {
    facebookLink: string;
    twitterLink: string;
    youtubeLink: string;
    linkedinLink: string;
    instagramLink: string;
    googlePlusLink: string;
    pinterestLink: string;

    constructor(private cotHttp: CotHttp) {
        this.setFooterLinkUrls();
    }

    getFooterData = (): Observable<GlobalPageSupport> => {
        return this.cotHttp.get(this.cotHttp.getConfiguredUrl(UrlDataEnum.RootUrl) + 'HarrowSchool/GetGlobalPageSupport');
    }

    private setFooterLinkUrls = () => {
        this.facebookLink = this.cotHttp.getConfiguredUrl(UrlDataEnum.FacebookLink);
        this.twitterLink = this.cotHttp.getConfiguredUrl(UrlDataEnum.TwitterLink);
        this.youtubeLink = this.cotHttp.getConfiguredUrl(UrlDataEnum.YoutubeLink);
        this.linkedinLink = this.cotHttp.getConfiguredUrl(UrlDataEnum.LinkedinLink);
        this.instagramLink = this.cotHttp.getConfiguredUrl(UrlDataEnum.InstagramLink);
        this.googlePlusLink = this.cotHttp.getConfiguredUrl(UrlDataEnum.GooglePlusLink);
        this.pinterestLink = this.cotHttp.getConfiguredUrl(UrlDataEnum.PinterestLink);
    }
}



// WEBPACK FOOTER //
// ./src/app/customizations/harrow/footer/harrow-footer.service.ts